import {RegisterModel} from '../models/register.model';
import {RegisterDto} from '../dtos/register.dto';
import {PatientModel} from '../models/patient.model';
import {PatientDto} from '../dtos/patient.dto';
import {AddPatientDto} from '../../appointment-selection/dtos/add-patient.dto';

export class PatientMapper {
  static toRegisterDto(registerModel: RegisterModel, customerId?: number, locationId?: number): RegisterDto {
    const [day, month, year] = registerModel.dateOfBirth.split('.');

    return {
      ...registerModel,
      dateOfBirth: `${year}-${month}-${day}`,
      countryCode: registerModel.countryCode.toUpperCase(),
      customerId: customerId,
      locationId: locationId
    };
  }

  static toCreateDto(registerModel: RegisterModel, customerId: number): AddPatientDto {
    const [day, month, year] = registerModel.dateOfBirth.split('.');

    return {
      ...registerModel,
      dateOfBirth: `${year}-${month}-${day}`,
      countryCode: registerModel.countryCode.toUpperCase(),
      customerId: customerId
    };
  }

  static toPatientDto(patientModel: PatientModel): PatientDto {
    const [day, month, year] = patientModel.dateOfBirth.split('.');

    return {
      ...patientModel,
      dateOfBirth: `${year}-${month}-${day}`,
      countryCode: patientModel.countryCode.toUpperCase(),
    }
  }

  static toPatientModel(patientDto: PatientDto): PatientModel {
    const [year, month, day] = patientDto.dateOfBirth.split('-');

    return {
      ...patientDto,
      dateOfBirth: `${day}.${month}.${year}`
    }
  }
}
